module.exports =
  localStorageKey: 'crmPluginConfigRestore'
